/**
 * Task Manager V2 — Frontend API Utils
 * يستخدم نفس الـ api instance من api.js
 */
import api from './api';

// ═══ TEAMS ═══
export const getTmTeams = () => api.get('/tm/teams').then(r => r.data);
export const createTmTeam = (data) => api.post('/tm/teams', data).then(r => r.data);
export const updateTmTeam = (id, data) => api.put(`/tm/teams/${id}`, data).then(r => r.data);
export const deleteTmTeam = (id) => api.delete(`/tm/teams/${id}`).then(r => r.data);
export const getTmTeamMembers = (id) => api.get(`/tm/teams/${id}/members`).then(r => r.data);
export const requestTmMember = (teamId, data) => api.post(`/tm/teams/${teamId}/members`, data).then(r => r.data);
export const approveTmMember = (teamId, memberId) => api.put(`/tm/teams/${teamId}/members/${memberId}/approve`).then(r => r.data);
export const rejectTmMember = (teamId, memberId) => api.put(`/tm/teams/${teamId}/members/${memberId}/reject`).then(r => r.data);
export const removeTmMember = (teamId, memberId) => api.delete(`/tm/teams/${teamId}/members/${memberId}`).then(r => r.data);

// ═══ SUPERVISORS ═══
export const getTmSupervisors = () => api.get('/tm/supervisors').then(r => r.data);
export const assignTmSupervisorClient = (svId, data) => api.post(`/tm/supervisors/${svId}/clients`, data).then(r => r.data);
export const unassignTmSupervisorClient = (svId, clientId) => api.delete(`/tm/supervisors/${svId}/clients/${clientId}`).then(r => r.data);
export const assignTmSupervisorTeam = (svId, data) => api.post(`/tm/supervisors/${svId}/teams`, data).then(r => r.data);
export const unassignTmSupervisorTeam = (svId, teamId) => api.delete(`/tm/supervisors/${svId}/teams/${teamId}`).then(r => r.data);
export const getTmSupervisorCommissions = (svId, params) => api.get(`/tm/supervisors/${svId}/commissions`, { params }).then(r => r.data);
export const getTmSupervisorTouchpoints = (svId) => api.get(`/tm/supervisors/${svId}/touchpoints`).then(r => r.data);
export const createTmTouchpoint = (svId, data) => api.post(`/tm/supervisors/${svId}/touchpoints`, data).then(r => r.data);
export const getTmSupervisorReminders = () => api.get('/tm/supervisors/reminders/pending').then(r => r.data);
export const getTmSupervisorPerformance = (svId) => api.get(`/tm/supervisors/${svId}/performance`).then(r => r.data);

// ─── SETTINGS ───
export const getTmRatePerSecond = async () => {
  try {
    const settings = await api.get('/settings/system').then(r => r.data);
    const rate = settings.find(s => s.key === 'tm_rate_per_second');
    return rate ? parseInt(rate.value) || 500 : 500;
  } catch { return 500; }
};

// ─── TASKS V2 ───
export const getTmClients = () => api.get('/tm/tasks/clients-list').then(r => r.data);
export const getTmSubscriptions = (clientId) => api.get(`/tm/tasks/subscriptions-list/${clientId}`).then(r => r.data);

export const getTmTasks = (params) => api.get('/tm/tasks', { params }).then(r => r.data);
export const createTmTask = (data) => api.post('/tm/tasks', data).then(r => r.data);
export const getTmTask = (id) => api.get(`/tm/tasks/${id}`).then(r => r.data);
export const updateTmTask = (id, data) => api.put(`/tm/tasks/${id}`, data).then(r => r.data);
export const assignTmTask = (id, data) => api.post(`/tm/tasks/${id}/assign`, data).then(r => r.data);
export const distributeTmTask = (id, data) => api.post(`/tm/tasks/${id}/distribute`, data).then(r => r.data);
export const cancelTmTask = (id, data) => api.post(`/tm/tasks/${id}/cancel`, data).then(r => r.data);
export const rejectTmTask = (id, data) => api.post(`/tm/tasks/${id}/reject`, data).then(r => r.data);
export const reopenTmTask = (id) => api.post(`/tm/tasks/${id}/reopen`).then(r => r.data);
export const archiveTmTask = (id) => api.put(`/tm/tasks/${id}/archive`).then(r => r.data);
export const deleteTmTask = (id) => api.delete(`/tm/tasks/${id}`).then(r => r.data);
export const reassignTmTask = (id, data) => api.post(`/tm/tasks/${id}/reassign`, data).then(r => r.data);
export const unassignTmTask = (id, data) => api.delete(`/tm/tasks/${id}/unassign`, { data }).then(r => r.data);
export const updateTmTaskSplitRatios = (id, data) => api.put(`/tm/tasks/${id}/split-ratios`, data).then(r => r.data);
export const getTmTaskActivity = (id) => api.get(`/tm/tasks/${id}/activity`).then(r => r.data);
export const uploadTmAttachment = (taskId, file, type = 'brief', submissionId) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('attachment_type', type);
  if (submissionId) fd.append('submission_id', submissionId);
  return api.post(`/tm/tasks/${taskId}/attachments`, fd, { 
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 5 * 60 * 1000 // 5 minutes for large briefs
  }).then(r => r.data);
};
export const getTmAttachments = (taskId) => api.get(`/tm/tasks/${taskId}/attachments`).then(r => r.data);

// ═══ SUBMISSIONS ═══
export const createTmSubmission = (data, files, onProgress) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => { if (v !== undefined && v !== null) fd.append(k, v); });
  if (files) {
    for (const file of files) { fd.append('files', file); }
  }
  return api.post('/tm/submissions', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 5 * 60 * 1000, // 5 minutes for large video uploads
    onUploadProgress: onProgress || undefined,
  }).then(r => r.data);
};
export const getTmSubmissions = (taskId) => api.get(`/tm/submissions/task/${taskId}`).then(r => r.data);
export const reviewTmSubmissionTL = (id, data) => api.put(`/tm/submissions/${id}/tl-review`, data).then(r => r.data);
export const reviewTmSubmissionSV = (id, data) => api.put(`/tm/submissions/${id}/sv-review`, data).then(r => r.data);
export const transferTmSubmission = (id, data) => api.post(`/tm/submissions/${id}/transfer`, data).then(r => r.data);

// ═══ EARNINGS ═══
export const getTmEarnings = (params) => api.get('/tm/earnings', { params }).then(r => r.data);
export const getTmEarningsSummary = (params) => api.get('/tm/earnings/summary', { params }).then(r => r.data);
export const getTmTeamEarnings = (teamId, params) => api.get(`/tm/earnings/team/${teamId}`, { params }).then(r => r.data);
export const getTmSecondsSummary = (params) => api.get('/tm/earnings/seconds-summary', { params }).then(r => r.data);
export const getTmMyDebts = () => api.get('/treasury/my-debts').then(r => r.data);
export const markTmEarningPaid = (id) => api.put(`/tm/earnings/${id}/mark-paid`).then(r => r.data);
export const markTmEarningsPaidBulk = (ids) => api.put('/tm/earnings/mark-paid-bulk', { ids }).then(r => r.data);
export const getTmLeadersDues = (params) => api.get('/tm/earnings/leaders-dues', { params }).then(r => r.data);
export const payAllLeaderDues = (data) => api.put('/tm/earnings/pay-all-leader-dues', data).then(r => r.data);
export const getTmDeliveriesReport = (params) => api.get('/tm/earnings/deliveries-report', { params }).then(r => r.data);

// ═══ COMMENTS ═══
export const addTmComment = (taskId, content) => api.post(`/tm/tasks/${taskId}/comments`, { content }).then(r => r.data);

// ═══ CHECKLISTS ═══
export const toggleTmChecklist = (checkId, is_completed) => api.put(`/tm/tasks/checklists/${checkId}/toggle`, { is_completed }).then(r => r.data);

// ═══ FILE DOWNLOADS ═══
export const getDownloadUrl = (attachmentId) => {
  const token = localStorage.getItem('token');
  return `/api/tm/submissions/download/${attachmentId}?token=${token}`;
};
export const getZipDownloadUrl = (taskId, type) => {
  const token = localStorage.getItem('token');
  return `/api/tm/submissions/task/${taskId}/zip?type=${type}&token=${token}`;
};


// ═══ COMPLAINTS ═══
export const createTmComplaint = (data) => api.post('/tm/complaints', data).then(r => r.data);
export const getTmComplaints = () => api.get('/tm/complaints').then(r => r.data);
export const respondToTmComplaint = (id, data) => api.put(`/tm/complaints/${id}`, data).then(r => r.data);
export const deleteTmComplaint = (id) => api.delete(`/tm/complaints/${id}`).then(r => r.data);

// ═══ NOTIFICATIONS ═══
export const getTmNotifications = (limit) => api.get('/tm/notifications', { params: { limit } }).then(r => r.data);
export const getTmUnreadCount = () => api.get('/tm/notifications/unread-count').then(r => r.data);
export const markTmNotificationRead = (id) => api.put(`/tm/notifications/${id}/read`).then(r => r.data);
export const markAllTmNotificationsRead = () => api.put('/tm/notifications/read-all').then(r => r.data);

// ═══ TEAM PAYMENT SETTINGS ═══
export const getTmPaymentSettings = (teamId) => api.get(`/tm/teams/${teamId}/payment-settings`).then(r => r.data);
export const saveTmPaymentSetting = (teamId, data) => api.post(`/tm/teams/${teamId}/payment-settings`, data).then(r => r.data);

// ═══ TEAM PAYMENTS (TL → Member) ═══
export const createTmTeamPayment = (teamId, data) => api.post(`/tm/teams/${teamId}/payments`, data).then(r => r.data);
export const getTmTeamPaymentsList = (teamId, params) => api.get(`/tm/teams/${teamId}/payments`, { params }).then(r => r.data);
export const getTmTeamPaymentsSummary = (teamId, params) => api.get(`/tm/teams/${teamId}/payments/summary`, { params }).then(r => r.data);

// Helper: Team Member يجيب دفعاته من كل فرقه
export const getTmTeamPayments = async (month) => {
  // أولاً نجيب فرق العضو
  const teams = await api.get('/tm/teams').then(r => r.data);
  let allPayments = [];
  for (const t of teams) {
    try {
      const payments = await api.get(`/tm/teams/${t.id}/payments`, { params: { month } }).then(r => r.data);
      allPayments = [...allPayments, ...payments];
    } catch {}
  }
  return allPayments;
};

// ═══ TEAM DEDUCTIONS (TL → Member خصومات) ═══
export const createTmDeduction = (teamId, data) => api.post(`/tm/teams/${teamId}/deductions`, data).then(r => r.data);
export const getTmDeductionsList = (teamId, params) => api.get(`/tm/teams/${teamId}/deductions`, { params }).then(r => r.data);
export const getTmDeductionsSummary = (teamId, params) => api.get(`/tm/teams/${teamId}/deductions/summary`, { params }).then(r => r.data);

// Helper: Team Member يجيب خصوماته من كل فرقه
export const getTmTeamDeductions = async (month) => {
  const teams = await api.get('/tm/teams').then(r => r.data);
  let allDeductions = [];
  for (const t of teams) {
    try {
      const deductions = await api.get(`/tm/teams/${t.id}/deductions`, { params: { month } }).then(r => r.data);
      allDeductions = [...allDeductions, ...deductions];
    } catch {}
  }
  return allDeductions;
};


// ═══ MEMBER FINANCIALS TOGGLE ═══
export const toggleMemberFinancials = (teamId, memberId, show_financials) => 
  api.put(`/tm/teams/${teamId}/members/${memberId}/toggle-financials`, { show_financials }).then(r => r.data);

// ═══ DASHBOARD ═══
export const getTmOwnerDashboard = (month) => api.get('/tm/dashboard/owner', { params: { month } }).then(r => r.data);
export const getTmSupervisorDashboard = (month) => api.get('/tm/dashboard/supervisor', { params: { month } }).then(r => r.data);
export const getTmTeamLeaderDashboard = (month) => api.get('/tm/dashboard/team-leader', { params: { month } }).then(r => r.data);
export const getTmTeamMemberDashboard = (month) => api.get('/tm/dashboard/team-member', { params: { month } }).then(r => r.data);

// ═══ HELPERS ═══
export const TM_STATUS_MAP = {
  DRAFT: { label: 'مسودة', color: 'gray' },
  ASSIGNED: { label: 'معيّنة', color: 'blue' },
  IN_PROGRESS: { label: 'قيد التنفيذ', color: 'yellow' },
  SUBMITTED: { label: 'مسلّمة', color: 'purple' },
  TL_APPROVED: { label: 'موافقة القائد', color: 'sky' },
  REVISION: { label: 'تعديلات', color: 'orange' },
  ACCEPTED: { label: 'مقبولة ✅', color: 'green' },
  LOST: { label: 'خسر ❌', color: 'red' },
  TRANSFERRED: { label: 'محوّلة', color: 'red' },
  CANCELLED: { label: 'ملغاة', color: 'gray' },
  ARCHIVED: { label: 'مؤرشفة 📦', color: 'gray' },
  REJECTED: { label: 'مرفوضة ❌', color: 'red' }
};

export const TM_STATUS_COLORS = {
  DRAFT: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300',
  ASSIGNED: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  IN_PROGRESS: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300',
  SUBMITTED: 'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300',
  TL_APPROVED: 'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300',
  REVISION: 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300',
  ACCEPTED: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
  LOST: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  TRANSFERRED: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  CANCELLED: 'bg-gray-200 text-gray-500 dark:bg-gray-800 dark:text-gray-500',
  ARCHIVED: 'bg-gray-300 text-gray-700 dark:bg-gray-800 dark:text-gray-400',
  REJECTED: 'bg-red-200 text-red-800 dark:bg-red-900/60 dark:text-red-300'
};

export const formatIQD = (n) => new Intl.NumberFormat('en-US').format(Math.round(n || 0)) + ' د.ع';
export const formatSeconds = (s) => {
  if (!s) return '0 ثانية';
  const num = Number(s);
  if (isNaN(num)) return s;
  return `${num.toLocaleString('en-US')} ثانية`;
};

export const MULTIPLIER_OPTIONS = [
  { value: 1, label: '1x (عادي)' },
  { value: 1.5, label: '1.5x' },
  { value: 2, label: '2x (مضاعف)' },
  { value: 2.5, label: '2.5x' },
  { value: 3, label: '3x (ثلاثي ⭐)' },
];

export const computeTaskValue = (seconds, multiplier = 1, rate = 500) => {
  return (seconds || 0) * (multiplier || 1) * rate;
};

// ── Supervisors list for dropdown ──
export const getSupervisorsList = () => api.get('/tm/tasks/supervisors-list').then(r => r.data);

// ── Role labels ──
export const TM_ROLE_LABELS = {
  owner: 'المالك',
  admin: 'مدير',
  supervisor: 'متابع',
  team_leader: 'قائد فريق',
  team_member: 'عضو فريق',
};
export const adjustTmEarning = (data) => api.post('/tm/earnings/adjust', data).then(r => r.data);
export const getTmMyReceivedPayments = (params) => api.get('/tm/earnings/my-received-payments', { params }).then(r => r.data);
